/**
 *
 * A
 *
 */

import styled from 'styled-components';
import { Link } from 'react-router';

import { COLORS } from 'utils/constants';

const Label = styled(Link)`
    color: ${COLORS.siteBlue};
    text-decoration: none;
    
    &:hover {
        color: ${COLORS.siteDarkBlue};
    }
`;

export default Label;



// WEBPACK FOOTER //
// ./src/components/A/index.js